export const generateSelectOptions = (from, to) => {
    let options = [];
    for (let i = from; i <= to; i++) {
      options.push({ value: i, label: (i < 10 ? "0" : "") + i.toString() })
    }
    return options;
  }

